import PropTypes from 'prop-types';
import { useState } from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { Box, Grid, Tab, Tabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PolicyIcon from '@mui/icons-material/Policy';
import SportsBaseballIcon from '@mui/icons-material/SportsBaseball';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

// project imports
import { SportsType } from './SportsType';
import { Cancellation } from './Cancellation';
import ConvenienceFee from './ConvenienceFee';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';

// tabs option
const tabsOption = [
    { label: 'Sports Type', icon: <SportsBaseballIcon sx={{ fontSize: '1.3rem' }} /> },
    { label: 'Cancelation Rules', icon: <PolicyIcon sx={{ fontSize: '1.3rem' }} /> },
    { label: 'Convenience Fee', icon: <CurrencyRupeeIcon sx={{ fontSize: '1.3rem' }} /> }
];
// tabs panel
function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
};
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
};

const AppSettings = () => {

    const theme = useTheme();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <MainCard>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Tabs
                        value={value}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChange}
                        aria-label="simple tabs example"
                        variant="scrollable"
                        sx={{
                            mb: 3,
                            '& a': {
                                minHeight: 'auto',
                                minWidth: 10,
                                py: 1.5,
                                px: 1,
                                mr: 2.25,
                                color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.550',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            '& a.Mui-selected': {
                                color: theme.palette.primary.main
                            },
                            '& .MuiTabs-indicator': {
                                bottom: 2
                            },
                            '& a > svg': {
                                marginBottom: '0px !important',
                                mr: 1.25
                            },
                            marginBottom: '0px !important'
                        }}
                    >
                        {tabsOption.map((tab, index) => (
                            <Tab key={index} component={Link} to="#" icon={tab.icon} label={tab.label} {...a11yProps(index)} />
                        ))}
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        <SportsType />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Cancellation />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <ConvenienceFee />
                    </TabPanel>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default AppSettings;
